export default {
    data() {
        return {
            frequencies: [
                { text: this.$t('campaigns.automatic.frequencies.7d'), value: 7, premium: true },
                { text: this.$t('campaigns.automatic.frequencies.14d'), value: 14 },
                { text: this.$t('campaigns.automatic.frequencies.21d'), value: 21 },
                { text: this.$t('campaigns.automatic.frequencies.30d'), value: 30 },
              ],
            delays: [
              { text: this.$t('campaigns.btc.delays.0m'), value: 0 },
              { text: this.$t('campaigns.btc.delays.30m'), value: 30 },
              { text: this.$t('campaigns.btc.delays.1h'), value: 60 },
              { text: this.$t('campaigns.btc.delays.2h'), value: 120 },
              { text: this.$t('campaigns.btc.delays.3h'), value: 180 },
              { text: this.$t('campaigns.btc.delays.6h'), value: 360 },
              { text: this.$t('campaigns.btc.delays.12h'), value: 720 },
              { text: this.$t('campaigns.btc.delays.1d'), value: 1440 },
              { text: this.$t('campaigns.btc.delays.3d'), value: 4320 },
              { text: this.$t('campaigns.btc.delays.7d'), value:  10080 },
              { text: this.$t('campaigns.btc.delays.14d'), value: 20160 }
            ]
        }
    },
    computed: {
        typeIcon() {
            return this.typeIconF(this.item?.scheduleType)
          },
          mediumIcon() {
            return '$mailing';
          },
          campaignType() {
            return this.campaignTypeF(this.item?.scheduleType);
          },
          segmentSuffix() {
            return this.item.segmentationType == 'AMOUNT_SPENT' ? this.formatCurrency(this.item?.domain.currency, true) : null;
          },
          segmentTag() {
            return this.item.segmentationType == 'TAG' ? this.tags?.find(t => t.id == this.item?.segment?.tagId)?.name: null;
          },
          segment() {
            if(!this.item) {
              return null;
            }
            if(this.item.segmentationType == 'ORDER_COUNT' && !this.item.segment.from && !this.item.segment.to) {
              return this.$t('campaigns.segmentationTypes.all.title');
            } else if(this.item.segmentationType == 'ORDER_COUNT') {
              return this.$t('campaigns.segmentationTypes.ordersCount.title');
            } else if(this.item.segmentationType == 'AMOUNT_SPENT') {
              return this.$t('campaigns.segmentationTypes.amountSpent.title');
            } else if(this.item.segmentationType == 'RFM') {
              return this.$t('campaigns.segmentationTypes.rfm.title');
            } else if(this.item.segmentationType == 'TAG') {
              return this.$t('campaigns.segmentationTypes.tag.title');
            }
            return 'By voko';
          },
         
          isAllSegment() {
            return this.item?.segmentationType == 'ORDER_COUNT' && !this.item.segment.from && !this.item.segment.to;
          },
          isTag() {
            return this.item?.segmentationType == 'TAG';
          },
          isScheduled() {
            return this.item?.scheduleType == 'SCHEDULED';
          },
          isAutomatic() {
            return this.item?.scheduleType == 'AUTOMATIC';
          },
          isBTC() {
            return this.item?.scheduleType == 'BACK_TO_CART';
          },
          isSWU() {
            return this.item?.scheduleType == 'SMART_WARM_UP';
          },
          isWelcome() {
            return this.item?.scheduleType == 'WELCOME';
          },
          evaluationWindow() {
             /*
             let windows = [
              { text: 'Last 7 days', value: '7d'},
              { text: 'Last 14 days', value: '14d'},
              { text: 'Last 1 month', value: '1m'},
              { text: 'Last 3 months', value: '3m'},
              { text: 'Last 6 months', value: '6m'},
              { text: 'Last year', value: '12m'},
             ]
             */
            let windows = ['7d','14d','1m','3m','6m','12m'].map(value => { return { text: this.$t(`common.periods.${value}`), value }});
            return windows.find(w => this.item?.evaluationPeriod?.window == w.value)?.text;
          },
          evaluationPeriod() {
            return `${this.formatDate(this.segment.from, true)} - ${this.formatDate(this.segment.to, true)}`;
          },
          sendStart() {
            if(this.formatDateTZ) {
              return this.formatDateTZ(this.startDate, false, this.$t('campaigns.scheduled.immediateStart'), this.item.domain.timezone);
            } else {
              return this.formatDate(this.startDate, false, this.$t('campaigns.scheduled.immediateStart'));
            }
          },
    },
    methods: {
        subjectIcon(i) {
            return (i < 9) ? `$num${i+1}` : `$num0`;
          },
        typeIconF(type) {
          switch(type) {
            case 'AUTOMATIC': return '$refresh';
            case 'BACK_TO_CART': return '$cart';
            case 'SCHEDULED': return '$scheduled';
            case 'SMART_WARM_UP': return '$swu';
            case 'WELCOME': return '$welcome';
            default: return '$scheduled';
          }
        },
        campaignTypeF(type) {
          switch(type) {
            case 'AUTOMATIC': return this.$t('campaigns.automatic.singular');
            case 'BACK_TO_CART': return this.$t('campaigns.btc.title');
            case 'SMART_WARM_UP': return this.$t('campaigns.swu.title');
            case 'WELCOME': return this.$t('campaigns.welcome.title');
            case 'SCHEDULED': 
            default: return this.$t('campaigns.scheduled.title');
          }
        }
    }
}